import { useContext, useEffect, useRef } from "react";
import { connectSocket, disconnectSocket } from "./socket";
import { registerSocketEvents } from "./socketEvents";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DriveContext } from "context/DriveContext";

const SocketProvider = ({ children, user }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { socketData } = useContext(DriveContext);

  const socketRef = useRef(null);

  // latest socketData
  const socketDataRef = useRef(socketData);


  useEffect(() => {
    socketDataRef.current = socketData;
  }, [socketData]);


  useEffect(() => {
    if (!user?.id) return;
    const socket = connectSocket(user);

    socketRef.current = socket;

    const cleanup = registerSocketEvents({
      dispatch,
      socket,
      socketDataRef,
      user,
      navigate,
    });

    return () => {
      cleanup?.();
      disconnectSocket(socket);
      socketRef.current = null;
    };
  }, [user?.id, dispatch, navigate]);

  return children;
};

export default SocketProvider;